import * as React from "react"
import { Flex, Text, Box } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import {
  brandingSelector,
  productCheckoutPageSelector
} from "../../../../recoil/atoms/room"
import { ProductSelectSmallMenuProps } from "./types"
import Select from "react-select"
import { ProductPrice } from "./product-price"
import { productOverlaySelector } from "../../../../recoil/atoms/product-overlay"
import { viewDependingLayoutAtom } from "../../../../recoil/atoms/view"
import { blendWithWhiteBackground } from "../../../../util"

const _ProductSelectSmallMenu: React.FC<ProductSelectSmallMenuProps> = ({
  optionsSelected,
  onChange,
  selectedQuantity,
  selectedVariant,
  setSelectedQuantity,
  setSelectedVariant,
  setOptionsSelected,
  isLargeDropDown,
  isLargeMenu,
  isSmallScreen,
  isProductWithoutOptions
}) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const isProductCheckoutPage = useRecoilValue(productCheckoutPageSelector)
  const smallOptionsContainerRef = React.useRef<HTMLDivElement>(null)
  const { options, variants, productTitle } = useRecoilValue(
    productOverlaySelector
  )
  const { isMobile, isLandscape } = useRecoilValue(viewDependingLayoutAtom)
  const customStyles = {
    container: (provided, state) => ({
      ...provided,
      width: "100%"
    }),
    control: (provided, state) => {
      /*  debugger  */
      return {
        ...provided,
        boxShadow: "none",
        minHeight: isMobile ? "30px" : isSmallScreen ? "20px" : "30px",
        backgroundColor:
          blendWithWhiteBackground(
            roomStyles.servicePanelElementModalBackground
          ) ?? "#e9ecef",
        border: roomStyles.servicePanelElementBorder
          ? `2px solid ${roomStyles.servicePanelElementBorder}b3`
          : "2px solid #ced4da",
        ":hover": {
          border: roomStyles.servicePanelElementBorder
            ? `2px solid ${roomStyles.servicePanelElementBorder}`
            : "2px solid #ced4da"
        },
        ":focus": {
          border: 0,
          boxShadow: "none"
        }
      }
    },
    placeholder: (provided, state) => ({
      ...provided,
      color: roomStyles?.servicePanelElementPrimaryText,
      opacity: 0.5,
      height: !isMobile && isSmallScreen && "20px",
      fontSize: !isMobile && isSmallScreen && "11px"
    }),
    option: (provided, state) => ({
      ...provided,
      color: roomStyles.servicePanelElementPrimaryText ?? "#495057",
      opacity: state.isSelected ? 1 : 0.75,
      height: !isMobile && isSmallScreen ? "20px" : isMobile ? "25px" : "30px",
      padding: isMobile ? "0px 8px" : "3px 8px",
      fontSize: isSmallScreen && !isMobile && "11px",
      backgroundColor: "unset",
      cursor: "pointer",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      ":hover": {
        opacity: 1
      },

      ":active": {
        backgroundColor: "unset"
      }
    }),
    menuList: (provided, state) => ({
      ...provided,

      borderRadius: "0.3rem",
      maxHeight: isLandscape && "100px"
    }),
    input: (provided, state) => ({
      ...provided,
      color: roomStyles.servicePanelElementPrimaryText ?? "#495057",
      margin: "0px",
      height: !isMobile && isSmallScreen && "20px",
      fontSize: !isMobile && isSmallScreen && "11px",
      cursor: "pointer"
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: roomStyles.servicePanelElementPrimaryText ?? "#495057",
      opacity: state.isSelected ? 1 : 0.75,
      paddingLeft: "0rem",

      ":hover": {
        opacity: 1
      }
    }),
    menu: (provided, state) => ({
      ...provided,
      background:
        blendWithWhiteBackground(
          roomStyles.servicePanelElementModalBackground
        ) ?? "#e9ecef",
      border: roomStyles.servicePanelElementBorder
        ? `2px solid ${roomStyles.servicePanelElementBorder}`
        : "2px solid #ced4da"
    }),
    indicatorSeparator: (provided, state) => ({
      ...provided,
      color: roomStyles.servicePanelElementPrimaryText ?? "#495057",
      background: roomStyles.servicePanelElementBackground ?? "#e9ecef",
      display: "none"
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: roomStyles.servicePanelElementPrimaryText ?? "#495057",
      height: !isMobile && isSmallScreen && "20px",
      fontSize: !isMobile && isSmallScreen && "11px"
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: !isMobile && isSmallScreen ? "20px" : "30px",
      cursor: "pointer"
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: !isMobile && isSmallScreen ? "20px" : "30px",
      padding: isSmallScreen ? "0 8px" : "0 6px",
      cursor: "pointer"
    })
  }

  return (
    <Flex
      flexDirection="column"
      /*  height="100%" */
      /*  marginLeft={!isSmallMenu && !isLandscape && "1rem"} */
      ref={smallOptionsContainerRef}
    >
      <Box display="grid">
        <Text
          fontSize="1.4rem"
          lineHeight={1.2}
          textOverflow="ellipsis"
          overflow="hidden"
          whiteSpace="nowrap"
          fontWeight="500"
          marginBottom={
            isMobile
              ? variants.length === 0
                ? "0.3rem"
                : "0.3rem"
              : variants.length === 0
              ? "0.3rem"
              : "0.3rem"
          }
          color={roomStyles?.badgeTextColor && roomStyles?.badgeTextColor}
          fontFamily={
            roomStyles?.badgeFontFamily && roomStyles?.badgeFontFamily
          }
        >
          {productTitle}
        </Text>
      </Box>
      {!isProductCheckoutPage && (
        <>
          {!isProductWithoutOptions && (
            <Flex marginBottom={variants.length === 0 ? "0rem" : "0.5rem"}>
              <Flex flexDir="column">
                {options.map(option => {
                  return (
                    <Flex
                      key={`${option.name}-text`}
                      marginBottom="0.4rem"
                      height={
                        isMobile ? "34px" : isSmallScreen ? "24px" : "34px"
                      }
                      alignItems="center"
                      _last={{ marginBottom: "0rem" }}
                    >
                      <Text
                        marginRight="0.3rem"
                        opacity={0.75}
                        fontSize={"0.7rem"}
                        color={
                          roomStyles?.badgeTextColor &&
                          roomStyles?.badgeTextColor
                        }
                        fontFamily={
                          roomStyles?.badgeFontFamily ?? "Assistant, sans-serif"
                        }
                      >
                        {option.name}
                      </Text>
                    </Flex>
                  )
                })}
              </Flex>

              <Flex flexDir="column" width="100%">
                {options.map(option => {
                  const onChangeSelect = data => {
                    onChange({
                      name: option.name,
                      value: data.value,
                      option_id: option.id
                    })
                  }

                  const optionsSelect = option.values.map(value => {
                    return { value: value, label: value }
                  })

                  const data =
                    optionsSelected[option.id] === undefined
                      ? undefined
                      : {
                          value: optionsSelected[option.id]?.value,
                          label: optionsSelected[option.id]?.value
                        }

                  return (
                    <Flex
                      key={`my_unique_select_key${option.name}`}
                      marginBottom="0.4rem"
                      maxWidth={isLargeDropDown && isLargeMenu && "400px"}
                      _last={{ marginBottom: "0rem" }}
                      onClick={e => e.stopPropagation()}
                    >
                      <Select
                        key={`my_unique_select_key__${option.name}`}
                        value={data}
                        styles={customStyles}
                        onChange={onChangeSelect}
                        options={optionsSelect}
                        isSearchable={false}
                        /* menuIsOpen={true} */
                      />
                    </Flex>
                  )
                })}
              </Flex>
            </Flex>
          )}

          <>
            <ProductPrice
              noDisplay={isSmallScreen && !isProductWithoutOptions}
              isNoSpaceForPrice={false}
              isProductWithoutOptions={isProductWithoutOptions}
              isSmallScreen={isSmallScreen}
              setSelectedQuantity={setSelectedQuantity}
              selectedVariant={selectedVariant}
              selectedQuantity={selectedQuantity}
            />
          </>
        </>
      )}
    </Flex>
  )
}

export const ProductSelectSmallMenu = React.memo(_ProductSelectSmallMenu)
